import Component from '@glimmer/component';
import CharacterAvatar from './character-avatar';

// Renders one row in the "Records & Awards" table.
// Args:
//   @row - object with:
//     icon       - left featured-info-img src (flag-record-icon / cup-award-icon)
//     iconAlt    - left img alt ('record-img' | 'award-img')
//     title      - left featured-info-text
//     date       - right column date string
//     hero       - optional { image, alt }; when present the description cell renders a
//                  'featured-info small' block with a hexagon avatar (record rows).
//                  When absent the description cell renders a plain 'table-text bold' (award rows).
//     description - the description text
export default class RecordAwardRow extends Component {
  <template>
    <div class='table-row'>
      <div class='table-row-item'>
        <div class='featured-info'>
          <img class='featured-info-img' src={{@row.icon}} alt={{@row.iconAlt}} />
          <p class='featured-info-text'>{{@row.title}}</p>
        </div>
      </div>
      <div class='table-row-item left'>
        {{#if @row.hero}}
          <div class='featured-info small'>
            <CharacterAvatar
              @image={{@row.hero.image}}
              @alt={{@row.hero.alt}}
              @size='small'
              @color='light'
              @prefix='featured-info-img'
            />
            <p class='featured-info-text'>{{@row.description}}</p>
          </div>
        {{else}}
          <p class='table-text bold'>{{@row.description}}</p>
        {{/if}}
      </div>
      <div class='table-row-item left'>
        <p class='table-text bold'>{{@row.date}}</p>
      </div>
    </div>
  </template>
}
